import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import en from "@/locales/en.json";
import hi from "@/locales/hi.json";

const DICTS = { en, hi };
const I18nContext = createContext({ lang: "en", t: (k, f) => f || k, setLang: () => {}, settings: null, refresh: async () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(localStorage.getItem("erp_lang") || "en");
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/settings");
      setSettings(r.data);
      const s = r.data?.language;
      if (s && DICTS[s] && s !== lang) { setLangState(s); localStorage.setItem("erp_lang", s); }
    } catch {}
  }, [lang]);

  useEffect(() => { refresh(); }, [refresh]);

  const t = useCallback((key, fallback) => {
    const dict = DICTS[lang] || DICTS.en;
    return dict[key] || fallback || key;
  }, [lang]);

  const setLang = useCallback((v) => {
    if (!DICTS[v]) return;
    setLangState(v);
    localStorage.setItem("erp_lang", v);
  }, []);

  return <I18nContext.Provider value={{ lang, t, setLang, settings, refresh }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
